import { e } from "./index865.mjs";
var n = e, t = /(?:ipad|iphone|ipod).*applewebkit/i.test(n);
export {
  t as e
};
